import CaptionWithBorders1 from "../../../components/ChapterImage/Image"
import { generateUnOrderedList, getCircleTypeListItem, getSquareTypeListItem, sectionStyle } from "../../../screens/JaldiLab/Chapters/ChapterList"


export const ImageDesc29 = {
    title: "Image 29: Examples of building entry and exit. ",
    para1: "The image shows the entrance of a building which has a ramp on the left and stairs on the left. The ramp has handrails on both sides. The stairs have lighting below every tread and handrails on both sides. The ramp and the stairs seem to be leading upto the reception of the building which has a counter and two doors. The reception area has several planters with green plants. ",
}

export const ImageDesc30 = {
    title: "Image 30- Examples of turnstiles used for security purposes.",
    para1: <>
        <p>
            The image shows two turnstiles at the entrance of a building which may be an airport. The turnstiles have space between them to let wheelchairs pass through. One of the turnstiles has a tactile paver going through to help persons with canes and visual impairments.
        </p>
        <p>There is a security personnel standing behind the turnstile on the right and a security personnel sitting behind the turnstile on the left.</p>
    </>,
}

export const ImageDesc31 = {
    title: "Image 31: Example of Parking Management System",
    para1: "The image shows a machine used for a parking management system which is a tech-based solution that streamlines the operation of parking spaces. This machine is a grey machine with a yellow counter. On the right side of a counter, there is a keypad and a screen. On the left side, there is a payment slot including a card slot. On top of the yellow counter, there is a board that reads “Pay & Park”. Next to this board there is a small blue board that says “PhonePe” in English and Hindi. The entire machine has a translucent cover around it. Some bollards can be seen to the right of the machine. ",
}

export const ImageDesc32 = {
    title: "Image 32- Examples of Drop-Off and Pick-Up Zones.",
    para1: <>
        <p>The image shows the reserved drop-off zone at the Bangalore airport. This is indicated by a black and yellow board which states “Reserved Drop-Off” in English, and also in Kannada and Hindi. There is a white outline in front of this board on the road which demarcates the drop-off area. There is a ramp leading up to the elevated airport area from the road with yellow tactile paver.</p>
        <p>There is a board on the left of this area which has an icon for baggage with baggage trolleys placed in front of it.  </p>
        <p>The Departure gate is at the right-most part of the image which has the term “Departures” written on it, in English, and also in Hindi and Kannada. </p>
    </>,
}

export const ImageDesc33 = {
    title: "Image 33: Examples of Segregated and Secure Parking for Ambulance.",
    para1: "This image shows a secure parking spot for an ambulance. The parking space is designated by a board that states “Ambulance Parking” in English, and also in Hindi and Kannada. The image also shows a green and white ambulance on the road next to the board. The space on the road is marked out with white lines on all sides of the ambulance. ",
}

export const ImageDesc34 = {
    title: "Image 34: Examples of Segregated and Secure Parking.",
    para1: "This image shows an example of segregated and secure parking of vehicles in a parking space. The shows 5 black and yellow taxis parked diagonally in the area designated with white outlines. There is a ramp to the left of the last taxi on the left side of the image. ",
}

export const ImageDesc35 = {
    title: "Image 35: Number of accessible parking bays needed in a building.",
    para1: <>
        <p>The image shows Table 3.1 from the Harmonised Guidelines 2021. It shows the number of vehicle parking units and the number of accessible parking bays required by regulation.</p>
        <p>
            <b>The table has two columns:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    `The first column is titled "Number of Vehicle Parking Units".`,
                    `The second column is titled "Number of Accessible Parking Bays".`
                ])}
            </div>
            <b>The table shows the following:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "For parking lots with 1 to 50 parking spaces, one accessible parking bay is required.",
                    "For parking lots with 51 to 100 parking spaces, one accessible parking bay is required.",
                    "For parking lots with 101 or more parking spaces, one accessible parking bay is required for every additional 100 parking spaces or fraction thereof.",
                ])}
            </div>
        </p>
    </>,
}

export const ImageDesc36 = {
    title: "Image 36: Examples of Accessible Family Parking.",
    para1: "This image shows a parking lot with a dedicated space for an accessible family parking spot. The spot has extra aisle space and is demarcated on the floor with a white outline and symbols showing a man, a woman, an infant and a baby in a crib. The spot next to this is also an accessible family parking spot with a vehicle parked in it.  ",
}

export const ImageDesc37 = {
    title: "Image 37: Examples of Accessible Parking.",
    para1: "This image shows three reserved accessible parking spaces. Each of the spaces is wider than standard parking spaces to allow for easier transfer from a wheelchair to the vehicle seat. They are demarcated with white lines and the international symbol of accessibility which is the wheelchair symbol.",
}

export const ImageDesc38 = {
    title: "Image 38: Accessible external environment",
    para1: "The image shows a pathway leading to a Court building which has a tactile paver running down the middle of it. The tactile paver can also be seen turning towards the right of the road at one point. The pathway is also lined with potted plants and flowers on either side.",
}

export const ImageDesc39 = {
    title: "Image 39: Accessible pathways with tactile pavers and bollards.",
    para1: "This image shows an accessible external pathway with tactile pavers and bollards.",
}

export const ImageDesc40 = {
    title: "Image 40: Examples of accessible corridors.",
    para1: "This image shows an accessible internal pathway with tactile pavers. The picture was taken in an airport and there is a board showing the path to the Exit written in English, Hindi and Kannada.",
}

export const ImageDesc41 = {
    title: "Image 41: Specifications for staircases.",
    para1: <>
        <p>The image is a technical diagram taken from the NBC that specifies the required unobstructed clearance for a door opening onto a staircase landing in the case of fire exits. This image has two figures showing plans of staircases.
        </p>
        <p>The figure at the top labelled as 4A shows a staircase plan indicating the minimum required unobstructed clearance when the exit door leaf encroaches on the landing in institutional and assembly buildings. The staircase plan 4A shows:
            <div className="figure_desc">
                {generateUnOrderedList([
                    "Text at the top specifying that the suggested location for a wet riser or fire hydrant should be clear of the door opening.",
                    "A double-leaf fire exit door that opens onto the staircase landing such that a specific clear distance (Dimension A) is maintained to ensure unimpeded movement when the door is fully opened.",
                ])}
            </div>
        </p>
        <p>Dimension A refers to the specific width of the staircase and the required clearance on the landing. A note specifies that the door width shall be based on the type of occupancy.
        </p>
        <p>
            The figure at the bottom shows a staircase plan labelled as 4B, which indicates the minimum required unobstructed clearance when a door leaf encroaches on the landing. The staircase plan 4B shows:
            <div className="figure_desc">
                {generateUnOrderedList([
                    "A single leaf door encroaching into the clear distance (Dimension A) is needed for unimpeded movement on the landing. ",
                    "The minimum clearance required (Dimension B) between the door swinging into the landing and the railing of the staircase."
                ])}
            </div>
        </p>
        <p>Dimension A refers to the specific width of the staircase and the required clearance on the landing. Dimension B refers to the minimum clearance from the door swing, where B should be greater than or equal to half of Dimension A.
        </p>
        <p>Overall, the diagram emphasizes the importance of ensuring adequate space for a door swinging into a corridor or landing to comply with building codes.</p>
    </>,
}

export const ImageDesc42 = {
    title: "Image 42: Examples of accessible staircase and an escalator.",
    para1: <>
        <p>
            This image is an example of an accessible staircase and an escalator. The staircase on the left has handrails on both sides and a tactile paver at the bottom of the staircase. The escalator on the right also has a tactile paver at the bottom.
            {/* <CaptionWithBorders1 image={ } /> */}
        </p>
        <p>
            Escalators, on the other hand, are not generally considered to be accessible unless they are also equipped with a wheelchair conveyor.  While some escalators have built-in detection systems to stop the escalator if it senses someone has fallen, they can still be dangerous for people with mobility impairments or who use walkers or canes.
        </p>
    </>,
}

export const ImageDesc43 = {
    title: "Image 43:  Example of staircase wheelchair for emergency evacuation.",
    para1: "This image shows a staircase wheelchair, also known as evacuation chairs, which are designed to be used to safely evacuate someone who uses a wheelchair down a flight of stairs in the event of an emergency. The chair is yellow in colour.",
}

export const ImageDesc44 = {
    title: "Image 44:  Examples of accessible lifts.",
    para1: <>
        <p>
            This image shows an accessible elevator. The lift has tactile pavers at the entrance. There is a signage on top of the elevator which has an icon of a wheelchair, a person with a cane and a person with an infant in a crib.
        </p>
        <p>The lift seems to be a lift at an airport. There is signage on the right of the lift that says “3 - This Floor” and “1- Departure”. There is additional signage on top which states “D6- D7”.</p>
    </>,
}

export const ImageDesc45 = {
    title: "Image 45- Details for hydraulic lifts for witness and Judge’s Bench in a Federal Courtroom",
    para1: <>
        <p>This image is a technical drawing of a witness stand and a Judge’s Bench in a Federal Courtroom. </p>
        <p>The witness box is on the right side of the image. It depicts a box with a seat in it. The labels in the diagram indicate “ Removable Step” and “Witness Stand Floor on a Mechanical Lift Platform”.</p>
        <p>The Judge’s Bench to the left of it. The labelling between the two stands indicates that there is an option that “Witness stand platform can be raised to Judge’s Bench level for Judge’s Access”. The Judge’s Bench has seating. The labelling indicates “Mechanical lift behind Bench, potentially with the landing extended over existing steps”.  </p>
    </>,
}

export const ImageDesc46 = {
    title: "Image 46:  Examples of mechanical lifts in the witness box.",
    para1: "The image shows a wooden witness stand in a courtroom. The witness box is equipped with mechanical lifts with buttons to manouevre to improve accessibility. ",
}

export const ImageDesc47 = {
    title: "Image 47: Examples of accessible kerb ramps.",
    para1: "The image shows an example of an accessible kerb ramp which is an inclined ramp leading upto a raised kerb with tactile pavers on it. ",
}

export const ImageDesc48 = {
    title: "Image 48: Examples of accessible internal ramps within the building.",
    para1: "The image shows a large hallway with a palm tree in the middle. On either side of the hallway there are internal ramps with handrails connecting one part of the building to the other. There are recessed lights in the ceiling throughout the hallway illuminating the space.",
}

export const ImageDesc49 = {
    title: "Image 49: Example of an accessible external ramp.",
    para1: "This image is an example of an accessible external ramp. The ramp has a metal railing on both sides, tactile pavers and a gentle slope. ",
}

export const FigureDesc20 = {
    title: "Figure 20: Six security zones represented on a  hypothetical site.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            The figure depicts a hypothetical site, upon which the boundaries of six security zones have been marked. The description is provided from the outermost perimeter to the innermost.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "At the bottom right of the layout, Zone I (Neighbourhood) is delineated.",
                    "At the centre of the layout, Zone II (Standoff Perimeter) is marked as a rectangle.",
                    "In the area created within Zone II, a separate, smaller rectangle is marked as Zone III (Site Access and Parking).",
                    "The rest of the area within Zone II is marked as Zone IV (Site).",
                    "Within Zone IV, a smaller rectangular boundary is marked as Zone V (Building Envelope).",
                    "The area created within Zone V is marked as Zone VI (Management & Building Operations).",
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc21 = {
    title: "Figure 21: Site design and security strategies.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            The plan shows the security strategies and site design for a Court Complex. The Court Complex site is rectangular and roads surround it on all four sides.  The Court building is situated in the middle of the site with setbacks on all four sides. The front setback is larger than the back, left and right setbacks. The back, right and front sides of the site are landscaped. The key for the plan is provided at the bottom right corner of the layout. The description has been provided from the outermost perimeter of the site to the innermost.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The outermost periphery of the Court Complex site has roads on all four sides. It is provided for vehicular circulation. It is denoted with grey dotted lines and is indicated in the key.",

                    "Along the periphery of the site, the next layer inside of the grey dotted lines is the standoff perimeter. This area is the security perimeter of the Court Complex between the vehicular and pedestrian paths. It is denoted by lines with green dashes, which is indicated in the key.",

                    "The next layer within the standoff perimeter is the pedestrian pathway, which is provided along the left, bottom, and right sides of the site. This is indicative of the pathways that are to be used by all users to enter the Court Complex. It is denoted by blue dotted lines, which is indicated in the key. ",

                    "Three rectangular security zones, comprising an area between the standoff perimeter and the pedestrian pathways, are marked at the entry / exit points to the site.  The first one is located at the entry / exit on the top right corner of the site.  The second rectangle is located at the entry / exit point at the right bottom corner of the site, which leads to the exit on the right side of the Court building. The third rectangular security zone is located at the entry / exit to the left bottom of the site, which leads to the front entrance of the Court building. These security zones are denoted by rectangles with orange coloured lines, which are also shown in the key. ",

                    "The next area is the setback surrounding the Court building. In the front setback of the Court building, to the right, space is provided for parking of four and two wheeler vehicles.",

                    ",Landscaping is shown in the front, left and back setback areas of the site, and the parking area.",

                    "In the left setback area of the site, space is allocated for two HVAC equipment. ",

                    "In the front setback, an Assembly Point for people to gather in the instance of a fire is indicated adjacent to the parking area. Gray dotted lines show the path from the building exits (front and left side of the building) to the Assembly Point.",

                    "The innermost perimeter is the Court Building. Along the building perimeter, the main entrance in the front is indicated with an orange triangle.  The two building exits, one adjoining the entrance and another to the left of the building, are indicated with gray triangles. ",

                    "An additional rectangular security zone, denoted by an orange line, is located at the front entry / exit of the Court building. ",

                    "Additionally, semi-covered space for parking is shown in the top left corner, adjoining the Court building.",

                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc22 = {
    title: "Figure 22: Segregated entry and exit at site level and building Complex. ",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            The plan shows the segregated entry and exit at site level and building level. The key for the plan is provided at the bottom right corner of the layout. The description has been provided in a clockwise direction.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The outermost periphery of the site is provided for vehicular circulation. This is denoted with a grey dotted line which is indicated in the key.",

                    "There are three different parking zones for the Judges, accused and the public. The Judges parking is shown adjoining the building and close to the back entrance which is at the top right corner of the layout. The accused parking is shown to the right side of the building along with a drop-off area near the right side entrance of the building. The public parking is shown in front of the building on the right side in the setback area which is at the bottom left corner of the layout.",

                    "There are three different security zones for each entry and exit, namely the Judges, accused and the public each depicted by orange rectangles. ",

                    "At the bottom left of the layout, a public entrance is provided. This is denoted by a green circle and the path leading to the Court building entrance is shown in green dashed lines. Green dotted lines from the entrance lead to the designated parking area for the public.",

                    "The entry and exit for the Judges has been provided at the top right, inner periphery, of the site.  The entry is denoted with an orange circle, and dashed orange lines lead to the dedicated Judges entrance at the rear of the Court building. Orange dotted lines indicate the path from the site entry to the dedicated Judges parking area adjoining the building.. ",

                    "To the bottom right, the inner periphery of the site is the space provided for the entry and the exit of the accused persons. This is denoted by a blue circle and a dashed line in blue indicates the path from the site entry to the Court building entrance. A blue dotted line indicates the path from the site entry to the dedicated parking for the accused.",

                    "None of the pathways provided overlap with each other ensuring secured and segregated pathways for all users. ",
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc23 = {
    title: "Figure 23: Segregated circulation of various user groups.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            The figure shows the ground floor and two floors of a typical Court Complex building, and the segregated entry and circulation through the building of four categories of users - Judges, litigants, witnesses, and accused persons. Each entry is indicated with a red arrow and the circulation paths are indicated by grey lines.
        </p>
        <p>
            The 3D render of the building depicts parking on the ground floor, including space for parking for cars towards the bottom left and covered basement parking. Lifts are provided on both sides of the building, and staircases are additionally provided on the right side. The ground floor of the building depicts an entrance leading to the Court building lobby and shows human figures entering the Court building; the first and second floors are left blank; and the third floor depicts a Courtroom.
        </p>
        <p>The description is provided in accordance with the circulation paths undertaken by each category of user.</p>

        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Judges’ entrance:
                        {getCircleTypeListItem([
                            "A separate entrance for Judges is provided at the left side of the building. ",
                            "Upon entering the building, the Judges are provided with a designated lift to reach the Courtrooms on the upper floors.",
                        ])}
                    </>,

                    <>
                        Witnesses’ entrance:
                        {getCircleTypeListItem([
                            "A separate entrance for witnesses is provided towards the back of the building.",
                            "Upon entering the building, the witnesses reach the entrance lobby on the ground floor, and are taken through a designated pathway to reach the Courtrooms on the upper floors. ",
                        ])}
                    </>,

                    <>
                        Accused persons’ entrance:
                        {getCircleTypeListItem([
                            "A separate entrance for accused persons is provided at the right side of the building.",
                            "Upon entering the building, the accused persons are provided with a designated lift to reach the Courtrooms on the upper floors. ",
                        ])}
                    </>,

                    <>
                        Litigants’ entrance:
                        {getCircleTypeListItem([
                            "An entrance for litigants is provided at the right side of the building, through the parking lots.",
                            "Upon navigating this pathway, the litigants reach the main public entrance on the ground floor. ",
                        ])}
                    </>,

                    "None of the pathways provided overlap with each other ensuring secured and segregated pathways for all users."

                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc24 = {
    title: "Figure 24 : Typical plan of segregated entrance for Judges.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            This diagram shows the segregated entrance for Judges. The Judges entrance to the Court building is on the left side of the layout.
        </p>
        <p>The features of the space are described from left to right of the layout.</p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The Judges entrance is at the left of the floor plan. There is a designated drop-off bay with accessible signage for  vehicles of Persons with Disabilities arriving at the Court entrance. A ramp is provided from the drop-off bay to the area in front of the entrance.",

                    "The steps provided in front of the building to enter the Complex have visual contrast strips and tactile paver.",

                    "To the bottom right of the plan, a ramp has also been illustrated leading upto the building. The ramp has a 1500 mm clear width and the landings have a turning dia of 1500 mm. ",

                    "There is landscaping on either side of the entrance steps as well as the ramp. ",

                    "Upon entering the building, the Judges proceed towards the security provisions ahead. ",

                    "The security provisions consist of two manned security stations, with provision for seating for Police Inspectors on either side. A full-body scanner is provided at the entrance doorway close to one of the  manned security stations. The entrance doorways have a clear width of 2000 mm.",

                    "Next to the entrance with the full-body scanner, a bag drop-off zone is provided along with a baggage scanner facility. Seating for Police Inspectors is provided next to the baggage scanner.",

                    "The baggage scanner leads to the bag pick-up zone. To the right of the bag pick-up zone, space is provided for an examination area for Police Inspectors to handle security concerns. A door leads to the security/detention room, which includes provision for a fire- safe locker.",

                    "Upon passing through the entrance doorways, the Judges collect their bags at the bag pick-up zone and proceed towards the turnstiles ahead. ",

                    "Three turnstiles are provided of 900 mm clear width. Two turnstiles are accessible, flap-based turnstiles with clear width and the third turnstile is a people-counter turnstile. Provision for seating for Police Inspectors is provided on either side of the turnstiles. ",

                    "Upon passing through the turnstiles, the Judges reach the Judge’s corridor.",

                    "At the left side of the corridor, a door is provided leading to the dedicated Judges  staircase and lifts leading to other floors, and this connects the Judge’s corridors to the administrative offices. ",

                    "Storage space with a door is shown in the staircase well space for storing wheelchairs.",

                    "The lift area and staircase has tactile pavers and the steps have colour contrast strips. ",

                    "The right side of the Judges corridor directs towards the Judge’s chamber. ",
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc25 = {
    title: "Figure 25: Typical plan of main entrance for advocates, litigants, and Court staff. ",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            This diagram shows the entrance for advocates, litigants and Court staff. The main entrance to the Court building is on the left side of the layout.
        </p>
        <p>The features of the space are described from left to right of the layout.</p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The main entrance is at the left of the floor plan. There is a designated drop-off bay with accessible signage for vehicles of Persons with Disabilities arriving at the Court entrance. A ramp is provided from the drop-off bay to the area in front of the entrance.  ",

                    "The steps provided in front of the building to enter the Complex have visual contrast strips and tactile pavers. ",

                    "To the bottom right of the plan, a ramp has also been illustrated leading upto the building. The ramp has a 1500 mm clear width and the landings have a turning dia of 1500 mm. ",

                    "There is landscaping on either side of the entrance steps as well as the ramp. ",

                    "Upon entering the building, the advocates, litigants, and Court staff proceed towards the security provisions ahead. ",

                    "The security provisions consist of two manned security stations, with provision for seating for Police Inspectors on either side. A full-body scanner is provided at the entrance doorway close to one of the manned security stations. The entrance doorways have a clear width of 2000 mm.",

                    "Next to the entrance with the full-body scanner, a bag drop-off zone is provided along with a baggage scanner facility. Seating for Police Inspectors is provided next to the baggage scanner.",

                    "The baggage scanner leads to the bag pick-up zone. To the right of the bag pick-up zone, space is provided for an examination area for Police Inspectors to handle security concerns. A door leads to the security/detention room, which includes provision for a fire-safe locker.",

                    "Upon passing through the gates, the advocates, litigants, and Court staff collect their bags at the bag pick-up zone and proceed towards the turnstiles ahead.",

                    "Three turnstiles of 900 mm clear width are provided. Two turnstiles are accessible, flap-based turnstiles with clear width and the third turnstile is a people-counter turnstile. Provision for seating for Police Inspectors is provided on either side of the turnstiles.",

                    "Upon passing through the turnstiles, the advocates, litigants, and Court staff reach the entrance lobby. The lobby comprises five information kiosks, including one accessible kiosk with wheelchair access. Drinking water provisions are located next to the kiosks.",

                    "At the left side of the lobby, a door is provided through which staircases and lifts to other floors may be accessed, and visitors may proceed to other parts of the Court Complex such as waiting rooms.",

                    "Storage space with a door is shown in the staircase well space for storing wheelchairs.",

                    "The lift area and staircase has tactile pavers and the steps have colour contrast strips.",

                    "At the right side of the lobby, a similar door is provided through which visitors may proceed to other parts of the Court Complex such as Filing Counters and other offices.",

                    "At the top-left corner of the lobby, a door is provided to the e-Seva Kendra room, which is described in Figure 57. ",
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc26 = {
    title: "Figure 26: Typical plan of segregated entrance for vulnerable witnesses.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            The Vulnerable witness entrance to the Court building is on the left side of the document.
        </p>
        <p>The features of the space are described from left to right of the document. </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The vulnerable witness entrance is at the left of the floor plan. There is a designated drop-off bay with accessible signage for vehicles of Persons with Disabilities arriving at the Court entrance. A ramp is provided from the drop-off bay to the area in front of the entrance.",

                    "The steps provided in front of the building to enter the Complex have visual contrast strips and tactile paver.",

                    "To the bottom right of the plan, a ramp has also been illustrated leading upto the building. The ramp has a 1500 mm clear width and  the landings have a turning dia of 1500 mm.",

                    "There is landscaping on either side of the  entrance steps as well as the ramp.",

                    "Upon entering the building, the witnesses proceed towards the security provisions ahead.",

                    "The security provisions consist of one manned security station, with provision for seating for Police Inspectors on either side. A full-body scanner is provided at the manned security station. The entrance doorway has a clear width of 2000 mm.",

                    "Next to the scanner, a bag drop-off zone is provided along with a baggage scanner facility. Seating for Police Inspectors is provided next to the baggage scanner.",

                    "The baggage scanner leads to the bag pick-up zone. To the right of the bag pick-up zone, space is provided for an examination area for Police Inspectors to handle security concerns. A door leads to the security/detention room, which includes provision for a fire-safe locker.",

                    "Upon passing through the gates, the witnesses collect their bags at the bag pick-up zone and reach the segregated entrance lobby, where seating is provided.",

                    "At the left side of the lobby, a door is provided through which a staircase- and lifts dedicated for the vulnerable witnesses are provided to access other floors, and the witnesses may proceed to the designated waiting areas.",

                    "Storage space with a door is shown in the staircase well space for storing wheelchairs.",

                    "The lift area and staircase has tactile pavers and the steps have colour contrast strips.",

                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc27 = {
    title: "Figure 27: Layout representing accessibility and circulation in the parking space.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            This image shows the layout of a parking complex including accessible parking spots, family parking spots and a designated parking spot for expecting mothers. The entrance to the parking area is on the right side of the layout.
        </p>
        <p>The features of the space are described from right to left of the layout.</p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The main entrance is at the right of the plan. There is a designated drop-off bay with accessible signage for vehicles of Persons with Disabilities arriving at the Court entrance. A ramp is provided from the drop-off bay to the area in front of the entrance. ",

                    "In this diagram, eight parking lots have been provided which are divided into four parking lots in two rows for parking vehicles. The two rows are separated by 2500 mm.",

                    <>
                        Top row: {getCircleTypeListItem([
                            "The two parking lots towards the right side of the row are reserved with signage for family parking and expecting mothers. These parking lots are 2600 mm in width. These lots are separated by an aisle space. There’s signage next to the designated parking spot as well as on it demarcating the space.",

                            "Towards the left of the parking lot reserved for expecting mothers, two parking lots are provided for general parking. These parking lots are 2500 mm in width and 5500 mm in length. These parking lots are separated from the reserved parking spaces by another aisle space.",

                        ])}
                    </>,
                    <>
                        Bottom row: {getCircleTypeListItem([
                            "The two parking lots towards the right side of the row are reserved with signage for accessible parking. These parking lots are 2600 mm in width. These lots are separated by an aisle space. ",

                            "Towards the left of the parking lot reserved for expecting mothers, two parking lots are provided for general parking. These parking lots are 2500 mm in width and 5500 mm in length. These parking lots are separated from the reserved parking spaces by another aisle space. There’s signage next to the designated parking spot as well as on it demarcating the space.",
                        ])}
                    </>,
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc28 = {
    title: "Figure 28: Plan for accessible reserved parking.",
    para1: <>
        <p><span><b>Orientation of the floor plan:</b> </span>
            This image shows the details of two reserved parking spots in a parking complex. The entrance to the parking area is on the right  side of the layout.
        </p>
        <p>The features of the space are described from right to left of the layout.</p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "The entrance of the parking space is at the right of the plan.",
                    "Two accessible parking lots with accessible signage are shown adjacent to each other, separated by an aisle area of 1200 mm. ",
                    "These parking lots are 2600 mm in breadth and 5500 mm in length. ",
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc29 = {
    title: "Figure 29: Minimum widths of a clear walkway for diverse user groups.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            the above figure provides the minimum width of the walkways to accommodate different user groups. The description is segregated for each figure alphabetically.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "Figure a- provides the width of  a walkway for a person using crutches. The width of the walkway is 1200 mm. The estimated width of the crutch being taken as 920 mm.",

                    "Figure b- is a description of a walkway for a person with a pram. The width of the walkway being 1200 mm.",

                    "Figure c- provides a description of a walkway for a person with a visual impairment using a white cane.  The width of the walkway being 1200 mm.",

                    "Figure d- the minimum width of a walkway for persons with visual impairment, using a sighted escort is 1200 mm.",

                    "Figure e- provides the minimum width of a walkway for a person using a walking cane. The minimum width of the person using the walking cane being 920 mm.",

                    "Figure f- The minimum width of the walkway for a person with a baby is 1200 mm. The width of the passage for the person being 920 mm.",

                    "Figure g- Provides the minimum width of the clear floor space to be 900mm. The length of the wheelchair being 1200 mm.",

                    "Figure h- is the description of the minimum clear turning space of a wheelchair to be 1500 mm.",

                    "Figure i- provides the minimum width of the walkway for a wheelchair and a person facing sideways adjacent to the wheelchair to be 1200 mm.",

                    "Figure j- is a minimum width of the walkway for a wheelchair and at the same time a person crossing the passage to be 1500 mm.",

                    "Figure k- provides a minimum width of two wheelchairs crossing side by side to be 1800 mm.",

                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc30 = {
    title: "Figure 30: Accessible corridor widths for diverse user groups.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            The plan shows the width of the corridors for diverse contexts. The features of the space are described starting from the corridors in the first line followed by the three corridors in the second line below it.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        In the first row:
                        {getCircleTypeListItem([
                            "The first illustration depicts that for a corridor to be accessible for a person on a wheelchair, the minimum width should be 1200 mm.",

                            "The second illustration depicts that for a corridor to be accessible for a person using crutches, the minimum width should be 1500 mm.",

                            "The third illustration depicts that for a corridor to be accessible for two persons using wheelchairs to cross side by side, the minimum width should be 1800 mm."

                        ])}
                    </>,
                    <>
                        In the second row:
                        {getCircleTypeListItem([
                            "The second row illustrates the above mentioned situation from a top view.",

                            "The first illustration depicts that for a corridor to be accessible for a person on a wheelchair such that another person walking by will be able to cross them without any hinderance, the minimum width should be 1200 mm. The diagram depicts to figures with a person on foot crossing a person using a wheelchair.",

                            "The second illustration depicts a person using crutches, a person using a wheelchair and a person with a cane. The illustration depicts that for all such persons using the same corridor, for them to cross each other without hindrance, the minimum width should 1500 mm.",

                            "The third illustration depicts that for a corridor to be accessible for two persons using wheelchairs to cross side by side, the minimum width should be 1800 mm.",

                        ])}
                    </>,

                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc31 = {
    title: "Figure 31: Details for accessible staircases.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            This plan shows two figures. Both the figures have been described one after the other.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    <>
                        Figure 1:
                        {getCircleTypeListItem([
                            "The upper figure is a floor plan showing the width of a flight of stairs, tactile pavers and the width of the wheelchair storage area that is located in the well space of the staircase.",

                            "The  first flight of steps begins at the ground level at the bottom right corner of the document and reaches a landing space. After turning 180 degrees at the landing, the next flight of steps runs parallel to the first flight leaving a stairwell between the two flights.  The second flight ends at the top right corner of the document and reaches the first floor level..",

                            "Tactile paver strips have been provided at the beginning of the flight, landing area and the end of the flight of steps.. The width of each row is 300 mm. There is a tactile paver on the landing. The width of the tactile paver is 300 mm.",

                            "The width of the landing is 1500 mm.",

                            "The width of each flight of stairs is 1500 mm and the width of each step (tread) is 300 mm.",

                            "Each step has a colour contrast strip on it. ",

                            "There is a provision for wheelchair storage below the staircase (called the spandrel) and in the stairwell. The length and width of the stairwell is 2300 mm and 1050 mm respectively.",

                            "A door is provided at the entrance to the storage space in the stairwell.",

                        ])}
                    </>,

                    <>
                        Figure 2:
                        {getCircleTypeListItem([
                            "The second figure is a section that shows three flights of stairs, the height of the railings, the width of the landings and the rise of the staircase.",

                            "Railings are provided along the stairs at two heights.The height of upper railing is recommended to be between 900 - 1000 mm and the height of the lower railing(called a guard rail) is recommended to be between 600 - 750 mm.",

                            "The length of the hand rail at the landing level is 300 mm.",

                            "Tactile paver strips have been provided at the beginning and end points of the staircase as well as the landings.The width of the pavers at the beginning of the flight of stairs measures 600 mm and the other width of the pavers at the top landing measures 300 mm.",

                            "The maximum rise for a flight of stairs is recommended to be 1800 mm.",

                        ])}
                    </>,
                ])}
            </div>
        </p>
    </>,
}


export const FigureDesc32 = {
    title: "Figure 32: Details for corridors, door clearance, and lifts.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            This figure is a floor plan that shows details for corridors, door clearance and lifts. The features of the figure are described space by space.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "There is a corridor waiting area to the right- middle of the plan. The waiting area has several entry and exit points leading to various spaces within the Court Complex.",

                    "The corridor waiting area has seating for persons along both sides including designated spaces for wheelchair users. Drinking water is provided in one corner of the corridor and a dustbin has been provided for waste disposal. The corridor also has potted plants to ensure greenery in the space and CCTV cameras for security.",

                    "One of the entry and exit corridors is next to the administrative office. The width of the corridor is 1500 mm. This entry/exit point is R.F.I.D Controlled.",

                    "The second entry/exit corridor is next to the Courtroom. The width of this corridor is 2000 mm. From the corridor a sliding door provides access to a Court Clerk’s Room, which is next to the Courtroom.",

                    "There is a corridor adjoining the Court Clerk’s Room that leads to the administrative offices. The width of the corridor is 2000 mm.",

                    "There is a double door in the top middle of the corridor. This door leads to amenities such as the staircase and the lift lobby. The width of the lift lobby is 4350 mm.",

                ])}
            </div>
        </p>
    </>,
}

export const FigureDesc33 = {
    title: "Figure 33: Plan of accessible external ramp.",
    para1: <>
        <p><span><b>Orientation:</b> </span>
            This figure is a floor plan that shows the details of an accessible external ramp. The features are described from the left to the right of the document.
        </p>
        <p><b>Description:</b>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "There are three flights of ramps. The first flight starts at the top left of the plan and goes up to a landing at the first level. After a 90 degree turn at the landing the second flight starts and reaches a second landing. After another 90 degree turn at this landing, the third flight of the ramp begins reaching to the third level.",

                    "There is a well space created between the first and third flights which has some landscape features.",

                    "The width of the walkway leading up to the first flight of the ramp is 1500 mm.",

                    "The start of the ramp has tactile pavers of 600 mm width. The distance between the tactile pavers and the beginning of the slope of the ramp is of the width of 300 mm.",

                    "At the ends of each of the flights of the ramps there are tactile paver strips. Similar tactile paver strips are there on the landings at the beginning of the second and third flights.  The width of the tactile paver is 300 mm. The landing has a turning radius of 1500 mm.",

                    "Accessible handrails shown with blue lines are provided along the two sides of the ramps and at the landings.",

                ])}
            </div>
        </p>
    </>,
}






